import React, { Component } from 'react';
import DropDown from '../DropDown';
import helpers from '../../Utils/helpers';
import { withTranslation } from 'react-i18next';
import { DropDownToggle } from '../DropDownToggle';
import DOMPurify from "dompurify";

class AoLeadsList extends Component {

    constructor(props) {
        super(props);
        this.initState = {
            filterState: localStorage.getItem("AoLeadDepartment"),
            filterOptions: false,
            isOpen: false,
            i: -1,
            filterUsed: false,
            selectedSalesPerson: null,
            filterSalesPersons: false
        }
        this.state = this.initState;
        this.filterChoices = this.filterChoices.bind(this);
        this.filterSalesPersons = this.filterSalesPersons.bind(this);
    }

    componentDidMount() {
        if (this.state.filterState === "cs" || this.state.filterState === "sale") {
            this.filterIsUsed(true)
        }
    }

    renderNoData() {
        const { t } = this.props
        return (<p>{t('aoleadslist.noentriesfound')}</p>);
    }

    onMoveToDetails(e, leadId) {

        if (e.target.className !== "preventRowClick" && e.target.tagName !== "INPUT" && e.target.tagName !== "SELECT" && e.target.tagName !== "BUTTON")
            this.props.moveToDetails(leadId)
    }

    assignTo(leadId, userId) {
        this.props.AssignTo(leadId, userId)
    }

    sortList() {
        const jsonSort = localStorage.getItem("sortOrder_aoLeads");
        return jsonSort ? JSON.parse(jsonSort) : [];
    }

    filterLeads = (filterState) => {
        localStorage.setItem("AoLeadDepartment", filterState.id);
        this.setState({ filterState: filterState.id });
        if (filterState.id !== "all") {
            this.filterIsUsed(true);
        } else {
            this.filterIsUsed(false)
        }
        this.filterChoices();
    }

    filterLeadsBySalesPerson = (filterState) => {
        if (filterState.id === "all") {
            this.setState({ selectedSalesPerson: null });
        } else {
            this.setState({ selectedSalesPerson: filterState.id });
        }

        this.filterSalesPersons();

    }

    filterChoices() {
        this.setState({ filterOptions: !this.state.filterOptions });
    }

    filterSalesPersons() {
        this.setState({ filterSalesPersons: !this.state.filterSalesPersons });
    }

    filterIsUsed(filter) {
        this.setState({ filterUsed: filter })
    }

    render() {
        const { leads, sortListByKey, salesPersons, user, listType, t } = this.props;

        if (!leads || leads.length === 0) {
            return this.renderNoData()
        }

        let filteredLeads = leads;
        const filter = this.state.filterState;
        const selectedSalesPerson = this.state.selectedSalesPerson;

        const sort = this.sortList();
        const sortOrder = sort.sortOrder === "asc" ? "pull-right vismaicon vismaicon-sm vismaicon-arrow-up-circle" : "pull-right vismaicon vismaicon-sm vismaicon-arrow-down-circle";
        const sortKey = sort.key;
        const closedList = listType === "closedList" ? true : false;
        const mainList = listType === "mainList" ? true : false;
        const searchList = listType === "searchList" ? true : false;
        const csLeads = leads.filter(lead => lead.departmentId ? lead.departmentId.substring(0, 3) === '605' : false);
        const saleLeads = leads.filter(lead => lead.departmentId ? lead.departmentId.substring(0, 3) !== '605' : true);
        const className = `${this.state.isOpen ? 'open' : ''}`;

        if (filter === "cs")
            filteredLeads = csLeads;

        if (filter === "sale")
            filteredLeads = saleLeads;

        if (selectedSalesPerson != null) {
            filteredLeads = filteredLeads.filter(lead => lead.assigneeUserId === selectedSalesPerson)
        }

        let showAssignColumn;

        if (mainList && salesPersons) {

            const userHasAllLeads = filteredLeads.every(lead => lead.assigneeUserId === user.id);

            const userExistInSalesPersonlist = salesPersons.some(item => item.id === user.id);

            if (!userHasAllLeads)
                showAssignColumn = true;

            if ((userExistInSalesPersonlist && userHasAllLeads) || !userExistInSalesPersonlist)
                showAssignColumn = false;

        }

        const filterList = [
            { id: 'all', label: t('aoleadslist.all') },
            { id: 'cs', label: t('aoleadslist.cs') },
            { id: 'sale', label: t('aoleadslist.sale') }
        ]

        const salesPersonsOptions = [
            { id: 'all', label: t('aoleadslist.all') }
        ];

        if (salesPersons) {
            salesPersons.filter(s => s.name != "").forEach(salesPerson => {
                var leadAmount = leads.filter(l => l.assigneeUserId === salesPerson.id).length
                if (leadAmount > 0)
                    salesPersonsOptions.push({ id: salesPerson.id, label: salesPerson.name + " - " + leadAmount + (leadAmount == 1 ? " lead" : " leads") })
            });
        }

        return <div className="table">
            <table className="table table-stripe table-hover">
                <thead>
                    <tr>
                        {mainList && <th className="text-left sortable" onClick={() => sortListByKey('priority')}>{t('aoleadslist.priority')} {sortKey === 'priority' && <i className={sortOrder}></i>}</th>}
                        <th className="text-left sortable" onClick={() => sortListByKey('customerNumber')}>{t('aoleadslist.customernumber')} {sortKey === 'customerNumber' && <i className={sortOrder}></i>}</th>
                        <th className="text-left sortable" onClick={() => sortListByKey('name')}>{t('aoleadslist.name')} {sortKey === 'name' && <i className={sortOrder}></i>}</th>
                        <th className="text-left sortable" onClick={() => sortListByKey('contact')}>{t('aoleadslist.contact')} {sortKey === 'contact' && <i className={sortOrder}></i>}</th>
                        {(mainList || searchList) && <th colSpan={showAssignColumn ? 2 : 1} className="text-left sortable"><DropDownToggle buttonLabel={t("aoleadslist.assignedto")} items={salesPersonsOptions} itemOnClick={this.filterLeadsBySalesPerson} /></th>}
                        {closedList && <th className="text-left sortable" onClick={() => sortListByKey('closedBy')}>{t('aoleadslist.closedby')} {sortKey === 'closedBy' && <i className={sortOrder}></i>}</th>}
                        {closedList && <th className="text-left sortable" onClick={() => sortListByKey('closed')}>{t('aoleadslist.closed')} {sortKey === 'closed' && <i className={sortOrder}></i>}</th>}
                        {searchList && <th className="text-left sortable" onClick={() => sortListByKey('isClosed')}>{t('aoleadslist.status')} {sortKey === 'isClosed' && <i className={sortOrder}></i>}</th>}
                        <th className="text-left sortable" width="150px"><DropDownToggle buttonLabel={t("aoleadslist.createdby")} items={filterList} itemOnClick={this.filterLeads} /></th>
                        <th className="text-left sortable" onClick={() => sortListByKey('dateCreated')}>{t('aoleadslist.created')} {sortKey === 'dateCreated' && <i className={sortOrder}></i>}</th>
                        <th className="text-left sortable" onClick={() => sortListByKey('lastAction')}>{t('aoleadslist.lastaction')} {sortKey === 'lastAction' && <i className={sortOrder}></i>}</th>
                        {closedList && <th className="text-left sortable" onClick={() => sortListByKey('amount')}>{t('aoleadslist.saleamount')} {sortKey === 'amount' && <i className={sortOrder}></i>}</th>}
                    </tr>
                </thead>
                <tbody>

                    {filteredLeads.map((lead, index) => {

                        let assignButtonHidden;
                        let priority = '';

                        if (lead.priorityType === "high")
                            priority = "vismaicon vismaicon-priority-high";
                        else if (lead.priorityType === "medium")
                            priority = "vismaicon vismaicon-priority-medium";
                        else if (lead.priorityType === "low")
                            priority = "vismaicon vismaicon-priority-low";

                        if (mainList && salesPersons) {

                            var currentUserExistInSalesPersons = salesPersons.some(item => item.id === user.id);

                            assignButtonHidden = user.id === lead.assigneeUserId || !currentUserExistInSalesPersons ? true : false;

                        }

                        return <tr className="cursorpointer" key={lead.id} onClick={(e) => this.onMoveToDetails(e, lead.id)}>
                            {mainList && <td><i className={priority}></i></td>}
                            <td>{lead.customerNumber}</td>
                            <td onMouseEnter={() => { this.setState({ isOpen: true, i: index }) }} onMouseLeave={() => { this.setState({ isOpen: false, i: index }) }}>
                                {lead.name}
                                {className && this.state.i === index && <span className="table-content-hover" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(lead.description) }}></span>}
                            </td>
                            <td>{lead.contact}</td>
                            {mainList && <td className="preventRowClick" style={{ minWidth: 200 }}>
                                <DropDown elementWidth={12} list={salesPersons} blankOption={true} value={lead.assigneeUserId} onChange={value => this.assignTo(lead.id, value)} />
                            </td>}
                            {closedList && <td>{lead.closedBy}</td>}
                            {closedList && <td>{helpers.formatDateAndTime(lead.dateClosed)}</td>}

                            {showAssignColumn && <td className="preventRowClick">
                                {!assignButtonHidden &&
                                    <div className="form-group">
                                        <button className="btn btn-default" onClick={() => this.assignTo(lead.id, user.id)}>{t('aoleadslist.assigntome')}</button>
                                    </div>
                                }
                            </td>}
                            {searchList && <td>{lead.assignedTo}</td>}
                            {searchList && <td>{lead.isClosed ? t('aoleadslist.closed') : t('aoleadslist.open')}</td>}
                            <td>{lead.createdBy}</td>
                            <td>{helpers.formatDateAndTime(lead.dateCreated)}</td>
                            <td>{lead.lastAction === null ? '' : `${lead.lastAction} ${lead.lastActionDate}`}</td>
                            {closedList && <td>{lead.amount > 0 ? helpers.currencyFormatter(lead.amount) : ""}</td>}
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    }
}

export default withTranslation()(AoLeadsList);